/**
 * パルの ひとこと の吹き出し(docs/07_learning_support.md §7.2)。
 *
 * パル画面のカードにも、リザルトの小さな吹き出しにも**同じ部品**を使う。
 * 話者の絵は `CharacterArt`(docs/14 のパル)で、表情は応答の `mood` をそのまま反映する。
 *
 * ことばはサーバーが作る(定型文フォールバックも含めて)。ここは出すだけ:
 *   - `loading` なら「かんがえちゅう…」
 *   - `reply` があれば ことば + みじかい ていあん(tips)
 *   - どちらでもなければ**何も描かない**(リザルトで枠だけ残さない)
 *
 * グラデーション禁止(CLAUDE.md ルール7)。1366×768 で崩れない幅にする。
 */
import type { TutorReply } from '../../services/tutor';
import { TUTOR_LABELS } from '../../services/tutor';
import { CharacterArt } from '../characters/CharacterArt';
import './tutor.css';

export interface TutorBubbleProps {
  readonly reply: TutorReply | null;
  /** 通信中(「かんがえちゅう…」を出す)。 */
  readonly loading?: boolean;
  /** `sm` = リザルトの小さい吹き出し / `md` = パル画面のカード。 */
  readonly size?: 'sm' | 'md';
}

export function TutorBubble({ reply, loading = false, size = 'md' }: TutorBubbleProps) {
  if (!reply && !loading) return null;

  const mood = loading ? 'normal' : (reply?.mood ?? 'normal');
  const tips = loading ? [] : (reply?.tips ?? []);

  return (
    <div className={`tutor-bubble ${size}`} data-mood={mood} data-loading={loading ? 'yes' : 'no'}>
      <CharacterArt
        speaker="pal"
        mood={mood}
        size={size === 'sm' ? 52 : 76}
        className="tutor-pal"
      />
      <div className="tutor-balloon" role="status">
        {loading ? (
          <p className="tutor-text tutor-thinking">{TUTOR_LABELS.loading}</p>
        ) : (
          <>
            <p className="tutor-text">{reply?.message}</p>
            {tips.length > 0 ? (
              <ul className="tutor-tips">
                {tips.map((tip) => (
                  <li key={tip}>{tip}</li>
                ))}
              </ul>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
}
